import React from "react";
import "./style.scss";

export const UserAgreementsText = () => {
	return (
		<div className="big-text">
			<h1>User Agreement</h1>
			<ul>
				<li>
					<h2>AGREEMENT</h2>
					<p>
						With User for the Provision of Online Bowling Services The terms and conditions of the Agreement take effect
						upon confirmation by the user. SIA TenPinCams has been registered with the Register of Enterprises of the
						Republic of Latvia under number 42103088398, acting by virtue of the Articles of Association, in
						consideration of partnership agreements with bowling clubs, providers of services of electronic payment
						system, in pursuance of the personal data processing policy, hereinafter referred to as ‘the Service
						Provider, enter into the present Agreement with the site user (hereinafter – ‘the User’) as follows:
					</p>
					<ul>
						The Service Provider provides within the framework of its activities the User with services as follows:
						<li> Remote bowling game with application of video cameras and of the Internet.</li>
						<li>Bowling remote tournaments.</li>
						<li>Bowling coaching.</li>
					</ul>
				</li>
				<li>
					<h2>Bowling Alleys</h2>
					<ul>
						<li>
							Bowling Centers with which the Service Provider has entered into Partnership Agreement on the deployment
							of video surveillance cameras (systems) for video recording of remote – controlled bowling game.
						</li>
						<li>Bowling clubs equipped with the set of Online Bowling equipment.</li>
					</ul>
				</li>
				<li>
					<h2>User</h2>
					<ul>
						<li>
							any natural person, who under the law is capable to conclude civil transactions in reliance upon the laws
							and rules existing in his country.
						</li>
						<li>
							the User is liable for the truthfulness of information provided, assumes full liability for the provision
							of false information and false personal data.
						</li>
						<li>the User is liable for the data updating, introduction of alterations, if necessary.</li>
						<li>
							the User is liable for the safety of information contained in the profile created on the site of the
							Service Provider, without transferring the access code to third parties, and undertakes not to disclose
							classified information, which can hurt interests of other users.
						</li>
						<li>
							The User may not give consent to the publication of bowling games, or coaching records unless approved by
							the Service Provider and by another user, for the placement in social networks or publication otherwise.
						</li>
					</ul>
				</li>
				<li>
					<h2>Payments</h2>
					<ul>
						<li>
							At registration with the electronic payment system integrated into the Platform, a personal account is
							created through which the user settles accounts with the Platform and from which the subscription fee is
							collected.
						</li>
						<li>All of the payments are made in euro (EUR).</li>
						<li>
							The User accepts that the subscription fee shall be debited from his /her personal account for the Service
							Provider, furthermore, fee for participation in Events, if the User has registered for such Events, as
							well as money prizes won by the User.
						</li>
						<li>
							Responsibility for operation and maintenance of the payment system, safety of the provided and used by the
							User payment cards rests with the owner of the Payment System.
						</li>
						<li>
							The Service Provider bears no responsibility for operation of this system, for information contained
							therein, requested information, credibility of the system, alterations in the system, updating and its
							operation in general.
						</li>
						<li>
							The use of the system is implemented at the cost of the User and for his convenience. The User
							straightforwardly deals with all matters associated with application of this system.
						</li>
						<li>
							The user is liable for the legitimacy of all payments made by him, liable for payment of all taxes, if
							any, in reliance upon the laws of the country of his /her residence due for money prizes won and received
							in bowling tournaments.
						</li>
					</ul>
				</li>
				<li>
					<h2>Participation in Tournaments</h2>
					<ul>
						<li>
							Participation in bowling tournaments is based on the user’s skills and bowling skills. The User is to be
							aware of his abilities and qualification as a bowler, on whom the game outcome depends.
						</li>
						<li>
							Prior to each tournament the User is provided with information concerning the tournament rules, charges
							for participation, quantity of participants, time of tournament, determination of the winner, money prizes
							on the website of the Service Provider. n bowling plays between the users the players harmonize the rules
							of the play, time of game, amount of the prize fund and procedure for determination of the winner.
						</li>
						<li>
							In bowling plays between the users the players harmonize the rules of the play, time of game, amount of
							the prize fund and procedure for determination of the winner.
						</li>
						<li>
							While participating in tournaments, also during mutual plays, the users are to follow the Playing Rules of
							the World Tenpin Bowling Federation (World Bowling Statutes and Playing Rules), follow the Code of Conduct
							in playing bowling, rules of tournaments concerned etc. information that is accessible on the website of
							the Service Provider.
						</li>
					</ul>
				</li>
				<li>
					<h2>General Rules</h2>
					<ul>
						<li>
							In the event of whatever disagreements, disputes or claims in connection with the use of the website,
							information published concerning the Service Provider, receiving services offers and other problems
							associated with the Service Provider and User, and / or other matters relating thereto, all such events
							shall be considered in reliance upon the laws existing in the Republic of Latvia.
						</li>
						<li>
							Where the parties concerned fail to reach an agreement on a dispute, the issue in controversy shall be
							submitted to court in the manner set out by laws of the Republic of Latvia.
						</li>
						<li>The Service Provider may seek recovery of losses from the User.</li>
					</ul>
				</li>
			</ul>
		</div>
	);
};
